module.exports = __webpack_public_path__ + "media/37.d766d2d0.mp3";